import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { Footer,Header, Layout } from '@davies-group/white-label-ui/ui';

import AssessmentPage from './containers/AssessmentPage';
import CompletedAssessmentPage from './containers/CompletedAssessmentPage';
import { useAppContext } from './context';

export function AppContainer()
{
	const appContext = useAppContext();

	return (
		<Layout
			header={<Header elevation={0} enableLogoHref={false}/>}
			footer={<Footer
				appName={window.__appSettings.applicationName}
				appVersion={window.__appSettings.applicationVersion}
				appCopyright={window.__appSettings.applicationCopyright}/>}
			isLoading={appContext.isLoading}
			maxWidth="md">
			<Routes>
				<Route path="assessment/completed/success" element={<CompletedAssessmentPage/>}/>
				<Route path="assessment/:assessmentId" element={<AssessmentPage/>}/>
				<Route path="assessment/:assessmentId/page/:pageIndex" element={<AssessmentPage/>}/>
				<Route path="*" element={<div>Page not found</div>}/>
			</Routes>
		</Layout>
	);
}

export default AppContainer;
